import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LabelGroup from 'components/Luxkit/Label/LabelGroup'
import Caption from 'components/Luxkit/Typography/Caption'
import Heading from 'components/Luxkit/Typography/Heading'
import React, { PropsWithChildren, ReactNode } from 'react'
import { HotelOfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'

interface Props {
  packageView: HotelOfferPackageOptionView
  packageNumber: number
  tagLineLabel?: ReactNode
}

function AccommodationPackageTileDetails(props: PropsWithChildren<Props>) {
  const {
    children,
    packageNumber,
    packageView,
    tagLineLabel,
  } = props

  return <VerticalSpacer gap={8}>
    {!!packageNumber && <Caption variant="large">Option {packageNumber}</Caption>}
    <div>
      {!tagLineLabel && <LabelGroup>{tagLineLabel}</LabelGroup>}
      <Heading variant="heading6">{packageView.package.name}</Heading>
    </div>
    {children}
  </VerticalSpacer>
}

export default AccommodationPackageTileDetails
